import { render, staticRenderFns } from "./templateHeight.vue?vue&type=template&id=4a20aa36&scoped=true"
import script from "./templateHeight.vue?vue&type=script&lang=js"
export * from "./templateHeight.vue?vue&type=script&lang=js"
import style0 from "./templateHeight.vue?vue&type=style&index=0&id=4a20aa36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20aa36",
  null
  
)

export default component.exports